import {
  SET_CLASS_USER_SCHOOL,
  SET_CLASS_USER_LEVEL,
  SET_CLASS_USER_FACULT
} from '@/store/mutation-types'

export default {
  [SET_CLASS_USER_SCHOOL] (state, payload) {
    state.searchClassUserSchool = payload
  },
  [SET_CLASS_USER_LEVEL] (state, payload) {
    state.searchClassUserLevel = payload
  },
  [SET_CLASS_USER_FACULT] (state, payload) {
    state.searchClassUserFacult = payload
  }
}



// WEBPACK FOOTER //
// ./src/components/class-users/store/mutations.js